import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import * as authService from '../../services/authService';
import { exportToPdf } from '../../services/pdfService';
import { PdfIcon } from '../icons/PdfIcon';
import { ChevronDownIcon } from '../icons/ChevronDownIcon';
import type { GenerationHistoryEntry } from '../../types';

export const HistoryPanel: React.FC = () => {
    const { user, setUser } = useAuth();
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    if (!user) return null;

    const handleDownloadHistoryPdf = async (entry: GenerationHistoryEntry) => {
        if (!user || !entry.inputs) return;
        await exportToPdf(entry.names, "Generated Names History", user.isPro, user.email, entry.inputs);
        const updatedUser = await authService.updateUserStat(user.uid, 'pdfsExported');
        if (updatedUser) {
            setUser(updatedUser);
        }
    };

    return (
        <div>
            <h2 className="text-xl font-bold text-[#1F2937] mb-4">Generated Names History</h2>
            <p className="text-sm text-gray-500 mb-2">Showing your last 50 generations.</p>
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 max-h-96 overflow-y-auto space-y-2">
            {user.generationHistory && user.generationHistory.length > 0 ? (
                user.generationHistory.map((entry, index) => (
                <div key={index} className="bg-white rounded-md border border-gray-200 p-2">
                    <button onClick={() => setExpandedIndex(expandedIndex === index ? null : index)} className="w-full flex justify-between items-center text-left transition-colors" aria-expanded={expandedIndex === index} aria-controls={`history-content-${index}`}>
                    <p className="font-semibold text-sm text-[#1F2937]">{new Date(entry.date).toLocaleString()} — <span className="font-normal text-[#6B7280]">{entry.names.length} names</span></p>
                    <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${expandedIndex === index ? 'rotate-180' : ''}`} />
                    </button>
                    <div id={`history-content-${index}`} className={`overflow-hidden transition-all duration-300 ease-in-out ${expandedIndex === index ? 'max-h-[1000px]' : 'max-h-0'}`}>
                    <div className="pt-3 mt-2 border-t border-gray-200">
                        <div className="flex justify-between items-center mb-2">
                        <div><p className="text-xs text-[#6B7280]"><strong>Industry:</strong> {entry.inputs.industry} | <strong>Keywords:</strong> {entry.inputs.keywords || 'N/A'} | <strong>Style:</strong> {entry.inputs.style} | <strong>Length:</strong> {entry.inputs.length}</p></div>
                        <button onClick={() => handleDownloadHistoryPdf(entry)} className="flex items-center gap-1 text-xs px-2 py-1 bg-gray-100 hover:bg-gray-200 text-[#1F2937] font-semibold rounded-md shadow-sm transition-colors duration-300"><PdfIcon /> PDF</button>
                        </div>
                        <ul className="space-y-1 text-sm">{entry.names.map((name, nameIndex) => (<li key={nameIndex} className="p-1 bg-gray-50 rounded-sm">{name.name}</li>))}</ul>
                    </div>
                    </div>
                </div>
                ))
            ) : (<p className="text-center text-[#6B7280]">You haven't generated any names yet.</p>)}
            </div>
      </div>
    );
};